/* royme — scheda prodotto: galleria, varianti, offerte a pezzi, carrello, barra fissa */
(function () {
  'use strict';
  if (window.__ryProductLoaded) return;
  window.__ryProductLoaded = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '€{{amount_with_comma_separator}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, dec, thou, decSep) {
      var num = (n / 100).toFixed(dec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return parts[1] ? whole + decSep + parts[1] : whole;
    }
    var m = format.match(re);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount': val = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      default: val = fmt(cents, 2, '.', ',');
    }
    return format.replace(re, val).replace(/<[^>]*>/g, '');
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function fmtDay(d) {
    try {
      return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1);
    }
  }

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function RyProduct(root) {
    this.root = root;
    var json = root.querySelector('[data-ry-json]');
    try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
    this.product = this.data.product;
    this.fmt = this.data.money_format;
    this.mode = root.getAttribute('data-mode') || 'variants';
    var vid = Number(root.getAttribute('data-variant-id'));
    this.variant = this.product.variants.filter(function (v) { return v.id === vid; })[0] || this.product.variants[0];
    this.atc = root.querySelector('[data-ry-atc]');
    this.stickyAtc = root.querySelector('[data-ry-sticky-atc]');
    this.sticky = root.querySelector('[data-ry-sticky]');
    this.form = root.querySelector('[data-ry-form]');
    this.initGallery();
    this.initOptions();
    this.initOffers();
    this.initButtons();
    this.initSticky();
    this.initEta();
    this.initModal();
    this.update();
  }

  /* ---------- Galleria ---------- */
  RyProduct.prototype.initGallery = function () {
    var self = this, root = this.root;
    this.track = root.querySelector('[data-ry-track]');
    this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ry-thumb]'));
    this.counter = root.querySelector('[data-ry-counter]');
    this.index = 0;
    if (!this.track || this.slides.length < 2) return;
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(Number(t.getAttribute('data-index'))); });
    });
    var prev = root.querySelector('[data-ry-prev]');
    var next = root.querySelector('[data-ry-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        if (i !== self.index) self.setActive(i, true);
      });
    }, { passive: true });
  };

  RyProduct.prototype.goTo = function (i) {
    if (!this.track || !this.slides.length) return;
    var n = this.slides.length;
    i = ((i % n) + n) % n;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    this.setActive(i, true);
  };

  RyProduct.prototype.setActive = function (i, moveThumbs) {
    this.index = i;
    this.thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    var th = this.thumbs[i];
    if (moveThumbs && th && th.parentNode) {
      var c = th.parentNode;
      c.scrollTo({ left: th.offsetLeft - c.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
    }
    if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
  };

  RyProduct.prototype.goToValue = function (value) {
    if (!this.slides.length || !value) return;
    var v = String(value).trim().toLowerCase();
    for (var i = 0; i < this.slides.length; i++) {
      if ((this.slides[i].getAttribute('data-color') || '') === v) { if (i !== this.index) this.goTo(i); return; }
    }
  };

  RyProduct.prototype.goToMedia = function (mediaId) {
    if (!this.slides.length || !mediaId) return false;
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { if (i !== this.index) this.goTo(i); return true; }
    }
    return false;
  };

  /* ---------- Varianti (pulsanti opzione) ---------- */
  RyProduct.prototype.initOptions = function () {
    var self = this;
    this.optionGroups = Array.prototype.slice.call(this.root.querySelectorAll('[data-ry-option]'));
    this.optionGroups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b || !g.contains(b)) return;
        each(g.querySelectorAll('[data-value]'), function (x) {
          x.classList.toggle('is-active', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        self.selectFromOptions(Number(g.getAttribute('data-ry-option')), b.getAttribute('data-value'));
      });
    });
  };

  RyProduct.prototype.selectFromOptions = function (changedIndex, changedValue) {
    var selected = this.optionGroups.map(function (g) {
      var a = g.querySelector('[data-value].is-active');
      return a ? a.getAttribute('data-value') : null;
    });
    var v = this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; });
    })[0];
    if (!v) v = this.product.variants.filter(function (v) { return v.options[changedIndex] === changedValue; })[0];
    if (!v) return;
    this.variant = v;
    this.optionGroups.forEach(function (g, i) {
      each(g.querySelectorAll('[data-value]'), function (x) {
        var on = x.getAttribute('data-value') === v.options[i];
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var lab = g.querySelector('[data-ry-option-label]');
      if (lab) lab.textContent = v.options[i];
    });
    if (!(v.featured_media && this.goToMedia(v.featured_media.id))) this.goToValue(changedValue);
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
    this.update();
  };

  /* ---------- Offerte a pezzi (1, 2, 3...) ---------- */
  RyProduct.prototype.initOffers = function () {
    var self = this;
    this.offers = Array.prototype.slice.call(this.root.querySelectorAll('[data-ry-offer]'));
    this.offers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-piece-value]');
        if (sw && o.contains(sw)) {
          var row = sw.closest('[data-ry-piece]');
          each(row.querySelectorAll('[data-piece-value]'), function (x) {
            var on = x === sw;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var lab = row.querySelector('[data-ry-piece-label]');
          if (lab) lab.textContent = sw.getAttribute('data-piece-value');
          self.goToValue(sw.getAttribute('data-piece-value'));
        }
        if (!o.classList.contains('is-active')) self.selectOffer(o); else self.update();
      });
      o.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === o) { e.preventDefault(); self.selectOffer(o); }
      });
    });
  };

  RyProduct.prototype.selectOffer = function (o) {
    this.offers.forEach(function (x) {
      var on = x === o;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.update();
  };

  RyProduct.prototype.currentOffer = function () {
    return this.offers.filter(function (o) { return o.classList.contains('is-active'); })[0] || this.offers[0];
  };

  RyProduct.prototype.variantFor = function (value) {
    var base = this.variant;
    var list = this.product.variants.filter(function (v) { return v.options[0] === value; });
    var exact = list.filter(function (v) {
      return v.options.every(function (o, i) { return i === 0 || o === base.options[i]; });
    })[0];
    return exact || list[0] || null;
  };

  RyProduct.prototype.offerLines = function (o) {
    var self = this;
    var rows = Array.prototype.slice.call(o.querySelectorAll('[data-ry-piece]'));
    var qty = Number(o.getAttribute('data-qty')) || 1;
    var picks = rows.map(function (r) {
      var a = r.querySelector('[data-piece-value].is-active');
      return a ? a.getAttribute('data-piece-value') : null;
    });
    if (!rows.length) { picks = []; for (var i = 0; i < qty; i++) picks.push(self.variant.options[0]); }
    var lines = [];
    picks.forEach(function (val) {
      var v = (val && self.variantFor(val)) || self.variant;
      var ex = lines.filter(function (l) { return l.id === v.id; })[0];
      if (ex) ex.quantity++;
      else lines.push({ id: v.id, quantity: 1, price: v.price, compare: v.compare_at_price || 0, available: v.available });
    });
    return lines;
  };

  RyProduct.prototype.offerTotals = function (o) {
    var lines = this.offerLines(o), sum = 0, units = 0, cmp = 0;
    lines.forEach(function (l) {
      sum += l.price * l.quantity;
      units += l.quantity;
      cmp += (l.compare > l.price ? l.compare : l.price) * l.quantity;
    });
    var disc = Math.round((parseFloat(String(o.getAttribute('data-discount') || '0').replace(',', '.')) || 0) * 100);
    var now = Math.max(sum - disc, 0);
    var was = units > 1 ? sum : cmp;
    return { now: now, was: was > now ? was : 0, lines: lines, available: lines.every(function (l) { return l.available; }) };
  };

  /* ---------- Aggiornamento prezzi e pulsanti ---------- */
  RyProduct.prototype.update = function () {
    var self = this, fmt = this.fmt, now, was, available;
    if (this.mode === 'offers' && this.offers.length) {
      this.offers.forEach(function (o) {
        var t = self.offerTotals(o);
        var n = o.querySelector('[data-ry-offer-now]');
        var w = o.querySelector('[data-ry-offer-was]');
        if (n) n.textContent = formatMoney(t.now, fmt);
        if (w) w.textContent = t.was ? formatMoney(t.was, fmt) : '';
      });
      var t = this.offerTotals(this.currentOffer());
      now = t.now; was = t.was; available = t.available;
    } else {
      now = this.variant.price;
      was = this.variant.compare_at_price > this.variant.price ? this.variant.compare_at_price : 0;
      available = this.variant.available;
      var pNow = this.root.querySelector('[data-ry-price-now]');
      var pWas = this.root.querySelector('[data-ry-price-was]');
      var pSave = this.root.querySelector('[data-ry-price-save]');
      if (pNow) pNow.textContent = formatMoney(now, fmt);
      if (pWas) { pWas.textContent = was ? formatMoney(was, fmt) : ''; pWas.hidden = !was; }
      if (pSave) {
        if (was) { pSave.textContent = (pSave.getAttribute('data-template') || 'Risparmi [x]').replace('[x]', formatMoney(was - now, fmt)); pSave.hidden = false; }
        else pSave.hidden = true;
      }
    }
    var label = available ? (this.atc && this.atc.getAttribute('data-label')) || 'Aggiungi al carrello' : (this.atc && this.atc.getAttribute('data-soldout')) || 'Esaurito';
    [this.atc, this.stickyAtc].forEach(function (b) {
      if (!b) return;
      b.disabled = !available;
      var l = b.querySelector('[data-ry-atc-label]');
      if (l) l.textContent = label;
      var p = b.querySelector('[data-ry-atc-price]');
      if (p) p.textContent = available ? formatMoney(now, fmt) : '';
    });
    var sp = this.root.querySelector('[data-ry-sticky-price]');
    if (sp) sp.innerHTML = formatMoney(now, fmt) + (was ? ' <s>' + formatMoney(was, fmt) + '</s>' : '');
    var input = this.root.querySelector('[data-ry-variant-input]');
    if (input) input.value = this.variant.id;
  };

  /* ---------- Carrello ---------- */
  RyProduct.prototype.lines = function () {
    if (this.mode === 'offers' && this.offers.length) {
      return this.offerTotals(this.currentOffer()).lines.map(function (l) { return { id: l.id, quantity: l.quantity }; });
    }
    return [{ id: this.variant.id, quantity: 1 }];
  };

  RyProduct.prototype.add = function () {
    var self = this;
    if (this.busy) return;
    var items = this.lines();
    if (!items.length) return;
    this.busy = true;
    var err = this.root.querySelector('[data-ry-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    var buttons = [this.atc, this.stickyAtc];
    buttons.forEach(function (b) { if (b) b.classList.add('is-loading'); });
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          if (err) { err.textContent = res.description || res.message || 'Non siamo riusciti ad aggiungere il prodotto. Riprova.'; err.hidden = false; }
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ry-product', productVariantId: items[0].id, cartData: res }); } catch (e) {}
        }
        if (cart && typeof cart.renderContents === 'function' && res && res.sections) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = base + 'cart';
        }
      })
      .catch(function () { window.location.href = base + 'cart'; })
      .then(function () {
        self.busy = false;
        buttons.forEach(function (b) { if (b) b.classList.remove('is-loading'); });
      });
  };

  RyProduct.prototype.initButtons = function () {
    var self = this;
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.add(); });
    else if (this.atc) this.atc.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
    if (this.stickyAtc) this.stickyAtc.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
  };

  /* ---------- Barra fissa in basso ---------- */
  RyProduct.prototype.initSticky = function () {
    var self = this;
    if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(this.atc);
  };

  /* ---------- Date di consegna (giorni lavorativi) ---------- */
  RyProduct.prototype.initEta = function () {
    var els = this.root.querySelectorAll('[data-ry-eta]');
    if (!els.length) return;
    var min = Number(this.root.getAttribute('data-eta-min')) || 5;
    var max = Number(this.root.getAttribute('data-eta-max')) || 8;
    var today = new Date();
    var txt = fmtDay(addBusinessDays(today, min)) + ' e ' + fmtDay(addBusinessDays(today, max));
    each(els, function (e) { e.textContent = txt; });
  };

  /* ---------- Finestre (guida taglie) ---------- */
  RyProduct.prototype.initModal = function () {
    var root = this.root;
    each(root.querySelectorAll('[data-ry-open]'), function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-ry-open'));
        if (!d) return;
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      });
    });
    each(root.querySelectorAll('dialog'), function (d) {
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-ry-close]')) {
          if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
        }
      });
    });
  };

  function init(scope) {
    each((scope || document).querySelectorAll('[data-ry-product]'), function (el) {
      if (el.__ry) return;
      el.__ry = new RyProduct(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
